<template>
  <nav class="navbar navbar-expand-md">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img src="./assets/branding.svg" style="height: 3rem" alt="TBS" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="true"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        v-if="contextStore.hasSecret"
        id="navbarSupportedContent"
        class="collapse navbar-collapse"
      >
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 nav nav-underline">
          <template v-if="contextStore.hasSecret">
            <li class="nav-item" role="button" @click="contextStore.logOut">
              <span class="nav-link">
                <i class="bi-door-open me-1" />
                <span>Log out</span>
              </span>
            </li>
            <li class="nav-item">
              <router-link to="/people" class="nav-link" active-class="active">
                <i class="bi-people me-1" />
                <span>People</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'bingo' }"
                class="nav-link"
                active-class="active"
              >
                <i class="bi-ticket-perforated me-1" />
                <span>Lunch bingo</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'group' }"
                class="nav-link"
                active-class="active"
              >
                <i class="bi-bookmark-heart me-1" />
                <span>Group view</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'desks' }"
                class="nav-link"
                active-class="active"
              >
                <i class="bi-pc-display-horizontal me-1" />
                <span>Desks</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'meetings' }"
                class="nav-link"
                active-class="active"
              >
                <i class="bi-chat-left-text me-1" />
                <span>Meeting rooms</span>
              </router-link>
            </li>
          </template>

          <li v-if="apiStore.isLoading" class="nav-item">
            <span class="nav-link disabled">
              <span
                class="spinner-border spinner-border-sm text-success"
                role="status"
              >
                <span class="visually-hidden">Loading...</span>
              </span>
              <span class="text-muted ms-1 text-success">Working...</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="container text-center align-items-center mt-4 mb-4">
    <div v-if="contextStore.isSafari" class="badge text-bg-warning mt-5">
      Safari is not supported and is known to have issues. Please use Chromium
      of Firefox instead.
    </div>

    <router-view></router-view>

    <div class="mt-4">
      <a
        href="https://gitlab.pik-potsdam.de/mcc-apsis/table-booking"
        target="_blank"
        class="text-muted link-underline link-underline-opacity-0"
      >
        <i class="bi-gitlab me-1" /> Code
      </a>
    </div>
  </div>

  <Toasts />
</template>

<script setup lang="ts">
import { useContextStore, useApiStore } from "./data/store.ts";
import Toasts from "./components/ToastsContainer.vue";

const contextStore = useContextStore();
const apiStore = useApiStore();
</script>
